<template>
	<div class="align-center">
		PWA Test
	</div>
</template>

<script>
	export default {
		mounted: function () {
	    	AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}))
	    },
	}
</script>


// WEBPACK FOOTER //
// src/components/pwa_test.vue